/**
 * Hero: poster first, then play video once (no loop) and fade poster out.
 */
(function () {
  const section = document.querySelector('[data-ryzup-video-hero]');
  if (!section) return;

  const video = section.querySelector('video');
  const poster = section.querySelector('.video-hero__poster');
  const posterWrap = section.querySelector('.video-hero__poster-wrap');
  if (!video) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function showPosterOnly() {
    section.classList.add('video-hero--poster-only');
    section.classList.remove('video-hero--video-playing');
    video.pause();
    video.removeAttribute('src');
    video.querySelectorAll('source').forEach((s) => s.remove());
  }

  function hidePoster() {
    section.classList.add('video-hero--video-playing');
    if (poster) {
      poster.setAttribute('aria-hidden', 'true');
    }
    if (posterWrap) {
      posterWrap.setAttribute('aria-hidden', 'true');
    }
  }

  if (reducedMotion.matches) {
    showPosterOnly();
    return;
  }

  function loadVideo() {
    if (video.dataset.loaded === 'true') return;
    video.dataset.loaded = 'true';
    video.loop = false;

    video.querySelectorAll('source').forEach((source) => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
    });
    video.load();

    video.addEventListener(
      'playing',
      () => {
        hidePoster();
      },
      { once: true }
    );

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          loadVideo();
          observer.disconnect();
        }
      },
      { rootMargin: '200px 0px' }
    );
    observer.observe(section);
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(loadVideo, { timeout: 2000 });
  } else {
    setTimeout(loadVideo, 500);
  }

  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) showPosterOnly();
  });
})();
